import type { FetchResult } from '@apollo/client';
import type { GetBaseViewerDataQuery } from 'generated/graphql';
import { isExamIngesting } from 'utils/examIngestion';

interface ShouldCacheBaseViewerDataResultParams {
  result: FetchResult<GetBaseViewerDataQuery>;
  ingestionTimeoutMs: number;
}

export function shouldCacheBaseViewerDataResult({
  result,
  ingestionTimeoutMs,
}: ShouldCacheBaseViewerDataResultParams): boolean {
  return !result.data?.worklistItems?.items.some((item) =>
    isExamIngesting(item.instancesLastUpdatedAt, ingestionTimeoutMs)
  );
}
